<template>
    <v-container fluid>
        <ApolloQuery
            :query="require('@/graphql/subscription/allSubscriptions.gql')"
            :variables="{ client_id: client_id, garbage: rando }"
            @result="subscriptionsLoaded"
        >
            <template v-slot="{ result: { loading, error, data } }">
                <v-progress-linear indeterminate v-if="loading" />
                <v-data-table
                    v-if="data && !loading"
                    :headers="headers"
                    :items="data.allSubscriptions"
                    item-key="id"
                    :items-per-page.sync="itemsPerPage"
                    :footer-props="{ itemsPerPageOptions }"
                >
                    <template v-slot:item.stripe_status="{ item }">
                        <v-chip
                            :color="subscriptionStatusMap[item.stripe_status].color"
                            :text-color="subscriptionStatusMap[item.stripe_status].text"
                            small
                        >{{ subscriptionStatusMap[item.stripe_status].name }}</v-chip>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon @click="showSubscription(item)" class="mr-2">
                            mdi-eye
                        </v-icon>
                        <v-btn :loading="itemEditing === item.id" icon>
                            <v-icon @click="editSubscription(item)">
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
                <v-alert type="error" v-else-if="error">
                    There was an error loading data. The server said...<br />
                    <strong>{{ error }}</strong>
                </v-alert>
            </template>
        </ApolloQuery>
    </v-container>
</template>

<script>
import { subscriptionStatusMap } from '@/subscriptionStatuses'

export default {
    name: 'SubscriptionsGrid',
    props: {
        reload: {
            type: Number,
            default: 0,
        },
        client_id: {
            type: String,
        },
    },
    data: () => ({
        itemsPerPageOptions: [25, 50, 100],
        itemsPerPage: 25,
        selected: [],
        rando: 0,
        headers: [
            { text: 'Status', value: 'stripe_status' },
            { text: 'User', value: 'user.name' },
            { text: 'Tier', value: 'name' },
            {
                text: 'Actions',
                align: 'right',
                sortable: false,
                value: 'action',
            },
        ],
        subscriptionStatusMap,
        itemEditing: null,
    }),
    watch: {
        reload: function(val) {
            this.rando = val
        },
    },
    computed: {
        query_vars: function() {
            return { client_id: this.client_id, garbage: this.rando }
        },
    },
    methods: {
        showSubscription(subscription) {
            this.$emit('show-subscription', subscription)
        },
        editSubscription(subscription) {
            this.itemEditing = subscription.id

            this.$apollo
                .mutate({
                    // Query
                    mutation: require('@/graphql/subscription/updateSubscription.gql'),
                    variables: {
                        id: subscription.id,
                    },
                })
                .then(({ data }) => {
                    // Redirects to customer portal
                    window.location.href = data.updateSubscription.url
                })
                .finally(() => {
                    this.itemEditing = null
                })
        },
        subscriptionsLoaded(result) {
            if (!result || result.loading || !result.data || !result.data.allSubscriptions) {
                return
            }

            const subscriptions = result.data.allSubscriptions

            this.$emit('subscriptions-loaded', subscriptions)
        },
    },
}
</script>
